export const FETCH_ROTA = "app/ROTA/FETCH_ROTA";
export const FETCH_ROTA_SUCCESS = "app/ROTA/FETCH_ROTA_SUCCESS";
export const FETCH_ROTA_FAILURE = "app/ROTA/FETCH_ROTA_FAILURE";
export const UPDATE_ROTA = "app/ROTA/UPDATE_ROTA";

export const BULK_PUBLISH = "app/ROTA/BULK_PUBLISH";
export const BULK_PUBLISH_SUCCESS = "app/ROTA/BULK_PUBLISH_SUCCESS";
export const BULK_PUBLISH_FAILURE = "app/ROTA/BULK_PUBLISH_FAILURE";

export const FETCH_ROTA_STAT = "app/ROTA/FETCH_ROTA_STAT";
export const FETCH_ROTA_STAT_SUCCESS = "app/ROTA/FETCH_ROTA_STAT_SUCCESS";
export const FETCH_ROTA_STAT_FAILURE = "app/ROTA/FETCH_ROTA_STAT_FAILURE";
export const UPDATE_STAT = "app/ROTA/UPDATE_STAT";

export const FETCH_SHIFTS = "app/ROTA/FETCH_SHIFTS";
export const FETCH_SHIFTS_SUCCESS = "app/ROTA/FETCH_SHIFTS_SUCCESS";
export const FETCH_SHIFTS_FAILURE = "app/ROTA/FETCH_SHIFTS_FAILURE";
export const UPDATE_SHIFTS = "app/ROTA/UPDATE_SHIFTS";
export const TOGGLE_PRINT = "app/ROTA/TOGGLE_PRINT";

export const SET_ALLOC_FILTERS = "app/ROTA/SET_ALLOC_FILTERS";

export const GET_SHIFT_STATS = "app/ROTA/GET_SHIFT_STATS";
export const GET_SHIFT_STATS_SUCCESS = "app/ROTA/GET_SHIFT_STATS_SUCCESS";
export const GET_SHIFT_STATS_FAILURE = "app/ROTA/GET_SHIFT_STATS_FAILURE";
